import { useEffect } from "react";

export default function useStaxACHValidations({
  data,
  isReady,
  onSuccess,
  onFailure,
}) {
  useEffect(
    function validateACH() {
      if (!isReady) return;

      const errors = [];

      if (!data.ach.accountType) {
        errors.push("empty_account_type");
      }

      if (
        !data.ach.accountType === "checking" ||
        !data.ach.accountType === "savings"
      ) {
        errors.push("invalid_account_type");
      }

      if (!data.ach.accountHolderType) {
        errors.push("empty_holder_type");
      }

      if (
        !data.ach.accountHolderType === "personal" ||
        !data.ach.accountHolderType === "business"
      ) {
        errors.push("invalid_holder_type");
      }

      if (!data.ach.accountNumber) {
        errors.push("empty_account_number");
      }

      if (!data.ach.routingNumber) {
        errors.push("empty_routing_number");
      }

      // TODO: we probably need more validations in here

      if (errors.length) {
        onFailure(errors);
      } else {
        onSuccess();
      }
    },
    [data, isReady, onSuccess, onFailure]
  );

  return null;
}
